import { h } from 'preact';

import style from './style.css';

function CategoryNav(props) {
    const { categoryStore, brandStore } = props.stores;
    const { queryFilter, total, view } = categoryStore;
    const { brands } = brandStore;

    return (
        <div>
            <small class='text-muted font-weight-lighter float-right mr-2'>
                Total: {total}<br />
            </small>

            <div class='btn-group mr-2' role='group'>
                <button id='btnGroupBrand' type='button' class={`btn btn-sm btn-${queryFilter.brand !== 'all' ? 'success' : 'outline-secondary'} dropdown-toggle`}
                    data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'
                    onClick={() => categoryStore.toggleView('brands')}
                >
                    Brands: {queryFilter.brand ? queryFilter.brand : 'All'}
                </button>
                <div class={`dropdown-menu ${view.brands ? 'show' : 'hide'}`} aria-labelledby='btnGroupBrand'>
                    <div class={`dropdown-item ${style.pointerCursor}`} 
                        onClick={() => categoryStore.toggleQueryfilter('brand', 'all', { setValue: true, toggle: () => categoryStore.toggleView('brands') })}
                    >All brands</div>
                    {brands.map(brand => (
                        <div class={`dropdown-item ${style.pointerCursor}`}
                            onClick={() => categoryStore.toggleQueryfilter('brand', brand.brandno, { setValue: true, toggle: () => categoryStore.toggleView('brands') })}
                        >{brand.name}</div>
                    ))}
                </div>
            </div>

            <div class='btn-group mr-2' role='group'>
                <button id='btnGroupLevel' type='button' class={`btn btn-sm btn-${queryFilter.level !=='all' ? 'success' : 'outline-secondary'} dropdown-toggle`}
                    data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'
                    onClick={() => categoryStore.toggleView('level')}
                >
                    Level: {queryFilter.level ? queryFilter.level : 'All'}
                </button>
                <div class={`dropdown-menu ${view.level ? 'show' : 'hide'}`} aria-labelledby='btnGroupLevel'>
                    <div class={`dropdown-item ${style.pointerCursor}`} onClick={() => categoryStore.toggleQueryfilter('level', 'all', { setValue: true, toggle: () => categoryStore.toggleView('level') })}>All levels</div>
                    {['main', 'intermediate', 'sub'].map(lvl => (
                        <div class={`dropdown-item ${style.pointerCursor}`} onClick={() => categoryStore.toggleQueryfilter('level', lvl, { setValue: true, toggle: () => categoryStore.toggleView('level') })}>{lvl}</div>
                    ))}
                </div>
            </div>

            <button class={`mr-2 btn btn-sm ${queryFilter.showOnConsumerWeb ? 'btn-success' : 'btn-outline-secondary'}`}
                onClick={() => categoryStore.toggleQueryfilter('showOnConsumerWeb')}
            >
                <i class={`fas fa-toggle-${queryFilter.showOnConsumerWeb ? 'on' : 'off'} mr-1`} />
                ConsumerWeb
            </button>
            <button class={`mr-2 btn btn-sm ${queryFilter.preSale ? 'btn-success' : 'btn-outline-secondary'}`}
                onClick={() => categoryStore.toggleQueryfilter('preSale')}
            >
                <i class={`fas fa-toggle-${queryFilter.preSale ? 'on' : 'off'} mr-1`} />
                PS
            </button>
            <button class={`mr-2 btn btn-sm ${queryFilter.hasNewProducts ? 'btn-success' : 'btn-outline-secondary'}`}
                onClick={() => categoryStore.toggleQueryfilter('hasNewProducts')}
            >
                <i class={`fas fa-toggle-${queryFilter.hasNewProducts ? 'on' : 'off'} mr-1`} />
                Has new products
            </button>
            <button class={`mr-2 btn btn-sm ${queryFilter.hasPresaleProducts ? 'btn-success' : 'btn-outline-secondary'}`}
                onClick={() => categoryStore.toggleQueryfilter('hasPresaleProducts')}
            >
                <i class={`fas fa-toggle-${queryFilter.hasPresaleProducts ? 'on' : 'off'} mr-1`} />
                Has PS products
            </button>
            <button class={`mr-2 btn btn-sm ${queryFilter.showall ? 'btn-success' : 'btn-outline-secondary'}`}
                onClick={() => categoryStore.toggleQueryfilter('showall')}
            >
                <i class={`fas fa-toggle-${queryFilter.showall ? 'on' : 'off'} mr-1`} />
                Show all
            </button>

            <span class='float-left form-row align-items-center mr-5'>
                <div class='col-auto'>
                    <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for categories...'
                        onInput={e => categoryStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                        value={queryFilter.search}
                    />
                </div>
                <div class='col-auto'>
                    <button type='button' class='btn btn-sm btn-primary' onClick={() => categoryStore.list()}>Search</button>
                </div>
            </span>
        </div>
    );
}

export default CategoryNav;


// WEBPACK FOOTER //
// ./components/categories/nav.js